import {actionTypes} from '../../../types';

// Action creator for generating OTP request
export const sendOtpToCreateAgency = (payload) => ({
    type: actionTypes.SEND_OTP_TO_CREATE_AGENCY_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const sendOtpToCreateAgencySuccess = (payload) => ({
    type: actionTypes.SEND_OTP_TO_CREATE_AGENCY_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const sendOtpToCreateAgencyFailure = (payload) => ({
    type: actionTypes.SEND_OTP_TO_CREATE_AGENCY_FAILURE,
    payload,
});

// Action creator for resetting OTP generation status
export const sendOtpToCreateAgencyReset = () => ({
    type: actionTypes.SEND_OTP_TO_CREATE_AGENCY_RESET,
});

// Action creator for resetting all OTP generation reducer
export const sendOtpToCreateAgencyResetAll = () => ({
    type: actionTypes.SEND_OTP_TO_CREATE_AGENCY_RESET_ALL,
});
